import type { ProductsSearchQuery } from '@/http/zamply/products/search-products-schema'

export const productsKeys = {
  all: ['products'] as const,
  catalogs: () => [...productsKeys.all, 'catalog'] as const,
  catalog: (query: ProductsSearchQuery) =>
    [...productsKeys.catalogs(), query] as const,
  details: () => [...productsKeys.all, 'detail'] as const,
  detail: (reference: string) =>
    [...productsKeys.details(), reference] as const,
}
